// Login.js
import React, { useState } from 'react';
import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserPool,
} from 'amazon-cognito-identity-js';
import {
  TextField,
  Button,
  Container,
  Paper,
  Box,
  Link,
} from '@mui/material';
import { styled } from '@mui/system';
import TypingLine from 'components/TypingLine';
import { useEffect } from 'react';



// v2: el verde Matrix se retira — terminal en la paleta de marca (IDENTIDAD_VISUAL.md §9)
const StyledContainer = styled(Container)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',

  backgroundColor: 'transparent',
  color: '#C77DFF',
  fontFamily: 'monospace',
});

const StyledPaper = styled(Paper)({
  backgroundColor: '#14141F',
  padding: '2rem',
  width: 'min(600px, 92vw)',
  minHeight: '400px',
  color: '#EDE9F7',
  fontFamily: 'monospace',
  border: '1px solid rgba(237,233,247,0.08)',
  borderRadius: '10px',
  boxShadow: 'none',
});

const StyledTextField = styled(TextField)({
  '& input': {
    color: '#EDE9F7',
    fontFamily: 'monospace',
    backgroundColor: 'transparent',
    padding: '6px',
  },
  '& .MuiInputBase-root': {
    borderBottom: '1px solid rgba(199,125,255,.4)',
  },
  '& .MuiInput-underline:before, & .MuiInput-underline:after': {
    borderBottom: '1px solid rgba(199,125,255,.4)',
  },
  '& label': {
    color: '#A8A3B8',
  },
});

const StyledButton = styled(Button)({
  marginTop: '1rem',
  color: '#C77DFF',
  borderColor: 'rgba(199,125,255,.4)',
  fontFamily: 'monospace',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: 'rgba(157,0,255,.08)',
  },
});

const Login = ({ onLogin, onNeedRegister }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [passErr, setPassErr] = useState('');
  const [stage, setStage] = useState(0);
  const [usernameEntered, setUsernameEntered] = useState(false);
  useEffect(() => {
  if (stage === 2 && username && !usernameEntered) {
     const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (regex.test(username)) {
      setUsernameEntered(true);
      setStage(3);
      }
    }
}, [stage, username, usernameEntered]);


  const handleLogin = () => {
    const userPool = new CognitoUserPool({
      UserPoolId: 'us-east-2_gCcm4sPzU',
      ClientId: '1k58piktqup5k1j852hau1nfqf',
    });

    const userData = { Username: username, Pool: userPool };
    const authenticationData = { Username: username, Password: password };

    const authenticationDetails = new AuthenticationDetails(authenticationData);
    const cognitoUser = new CognitoUser(userData);
    setPassErr("");
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (session) => {
        console.log('Sesión iniciada con éxito:', session);
        onLogin(cognitoUser, session);
      },
      onFailure: (err) => {
        console.error('Error al iniciar sesión:', err);
        setPassErr(err.message);
      },
    });
  };

  return (
    <StyledContainer>
      <StyledPaper>
        {stage >= 0 && (
          <TypingLine
            text="Booting OverPower.TV Console..."
            onDone={() => setStage(1)}
          />
        )}

        {stage >= 1 && (
          <Box mt={2}>
            <TypingLine
              text="login@overpower.tv:~$"
              onDone={() => setStage(2)}
            />
          </Box>
        )}

        {stage >= 2 && (
          <Box mt={1}>
            <StyledTextField
              fullWidth
              variant="standard"
              placeholder="email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
          
              autoFocus
            />
          </Box>
        )}

        {stage >= 3 && (
          <Box mt={2}>
            <TypingLine text="password:" onDone={() => setStage(4)} />
          </Box>
        )}

        {stage >= 4 && (
          <>
            <StyledTextField
              fullWidth
              variant="standard"
              type="password"
              placeholder="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
               onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleLogin();
                }
              }}
            />
            
          </>
        )}

        <StyledButton fullWidth variant="outlined" onClick={handleLogin}>
              acceder
            </StyledButton>
            <TypingLine text={passErr} isError = 'true'/>
            <Box mt={2}>
              <Link
                onClick={onNeedRegister}
                sx={{ color: '#C77DFF', fontFamily: 'monospace', cursor: 'pointer' }}
              >
                crear nuevo usuario
              </Link>
            </Box>
      </StyledPaper>
    </StyledContainer>
  );
};

export default Login;
